module.exports = __webpack_public_path__ + "img/Dantam Hair 43.a7d07485.jpg";